<template>
  <div>
    <form
      autocomplete="off"
      class="a-form-column m-tinymce-primary"
      name="create-notice-form"
      @submit.prevent="updateContenidoEntregable"
    >
      <AtomSelectPrimary
        v-model.number="entrega"
        v-show="entregable.entregable.tipo === 'mensaje'"
        :elements="tiposDeEntrega"
        :inputError="$v.entrega.$error"
        keyField="id"
        :label="$t('mEditionMapActivationSendingOfDeliverablesEdit.inputs.entrega.label')"
        :messageError="messageErrorEntrega"
        name="entrega"
        textField="nombre"
        @blur="$v.entrega.$touch()"
      />

      <transition name="a-transtion-slide">
        <AtomInputPrimary
          v-model.number="entregable.entregable.dia"
          v-show="entrega == 1"
          :disabled="entregable.entregable.tipo === 'nodo'"
          :inputError="$v.entregable.entregable.dia.$error"
          :label="$t('mEditionMapActivationSendingOfDeliverablesEdit.inputs.dia.label')"
          message=""
          :messageError="messageErrorDia"
          min="0"
          name="dia"
          type="number"
          @blur="$v.entregable.entregable.dia.$touch()"
        />
      </transition>

      <AtomInputPrimary
        v-model="entregable.entregable.asunto"
        :inputError="$v.entregable.entregable.asunto.$error"
        :label="$t('mEditionMapActivationSendingOfDeliverablesEdit.inputs.asunto.label')"
        :message="$t('mEditionMapActivationSendingOfDeliverablesEdit.inputs.asunto.message')"
        :messageError="messageErrorAsunto"
        name="asunto"
        type="text"
        @blur="$v.entregable.entregable.asunto.$touch()"
      />

      <AtomTinymcePrimary
        v-model="entregable.entregable.mensaje"
        :inputError="$v.entregable.entregable.mensaje.$error"
        :label="$t('mEditionMapActivationSendingOfDeliverablesEdit.inputs.mensaje.label')"
        :messageError="messageErrorMensaje"
        name="mensaje"
        @onBlur="$v.entregable.entregable.mensaje.$touch()"
      />

      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionMapActivationSendingOfDeliverablesEdit',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionMapActivationSendingOfDeliverablesEdit.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      diaInicial: 0,
      entrega: '',

      entregable: {
        academia: '',
        entregable: {}
      },

      tiposDeEntrega: [
        {
          id: 0,
          nombre: 'Inmediato'
        },

        {
          id: 1,
          nombre: 'Personalizar día'
        }
      ]
    }
  },

  validations: {
    entrega: {
      required
    },

    entregable: {
      entregable: {
        asunto: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        },

        dia: {
          minLength: minLength(0),
          required
        },

        mensaje: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorAsunto () {
      return this.$validation.getValidationMessage('mEditionMapActivationSendingOfDeliverablesEdit', this.$v.entregable.entregable.asunto, 'asunto')
    },

    messageErrorDia () {
      return this.$validation.getValidationMessage('mEditionMapActivationSendingOfDeliverablesEdit', this.$v.entregable.entregable.dia, 'dia')
    },

    messageErrorEntrega () {
      return this.$validation.getValidationMessage('mEditionMapActivationSendingOfDeliverablesEdit', this.$v.entrega, 'entrega')
    },

    messageErrorMensaje () {
      return this.$validation.getValidationMessage('mEditionMapActivationSendingOfDeliverablesEdit', this.$v.entregable.entregable.mensaje, 'mensaje')
    }
  },

  watch: {
    entrega () {
      this.entregable.entregable.dia = this.entrega === 0 ? 0 : this.diaInicial
    }
  },

  created () {
    this.entregable.entregable = Object.assign({}, this.$store.getters.getAssetSelectedDeliverable)
    if (Object.values(this.entregable.entregable).length) {
      this.entregable.academia = this.$store.getters.getAcademyData.id
      this.entrega = this.entregable.entregable.dia === 0 ? 0 : 1
      this.diaInicial = this.entregable.entregable.dia
    } else {
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}/${this.$t('mEditionMenu.map.activation.children.sendingOfDeliverables.subedition')}`)
    }
  },

  methods: {
    updateContenidoEntregable () {
      console.log(this.$route.params)
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('contenido', 'updateContenidoEntregable', this.entregable, [this.$route.params.subid])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionMapActivationSendingOfDeliverablesEdit', 'updateContenidoEntregable', 'success')
            this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}/${this.$t('mEditionMenu.map.activation.children.sendingOfDeliverables.subedition')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapActivationSendingOfDeliverablesEdit', 'updateContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
